import React from 'react';
import '../assets/css/nav-footer.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import footerLogo from '../assets/images/logo.png';

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-logo">
          {/* <img src={footerLogo} alt="eSupport" /> */}
        </div>
        <div className="footer-nav">
          <a href="/">Home</a>
          <a href="/Courses">Courses</a>
          <a href="#">Advertise</a>
          <a href="/AboutUs">About Us</a>
          <a href="/Contact">Contact</a>
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
        </div>
        {/*<div className="social-links">*/}
        {/*  <a href="#"><i className="fab fa-facebook"></i></a>*/}
        {/*  <a href="#"><i className="fab fa-whatsapp"></i></a>*/}
        {/*  <a href="#"><i className="fab fa-linkedin"></i></a>*/}
        {/*  <a href="#"><i className="fas fa-envelope"></i></a>*/}
        {/*  <a href="#"><i className="fab fa-youtube"></i></a>*/}
        {/*  */}
        {/*</div>*/}

        <div className="social-links">
          <a href="https://www.facebook.com/share/16ZXfRnfm5/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://whatsapp.com/channel/0029Vb5QkDi7YScwcvgVoL31" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-whatsapp"></i>
          </a>
          <a href="https://www.tiktok.com/@dskills76?_t=ZS-8xKakM8lHWy&_r=1" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-tiktok"></i>
          </a>
          <a href="https://www.instagram.com/invites/contact/?igsh=13t3vvvt0oil2&utm_content=w271u8t" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.youtube.com/channel/UCOBC6Bjpgpncf5MhjPrWjhg" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-youtube"></i>
          </a>
        </div>


        <p className="copyright ">
          &copy; 2024 Skills Sri Lanka. All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
